import { api } from "@shared/lib/api";
import { BackednResponse, IGetFaectValue } from "@shared/lib/types";
import {
  IBillingFacets,
  IBrandBilling,
  IGetBrandBilling,
} from "@shared/lib/types/brandBilling";

import { IGetCampaigns } from "@shared/lib/types/campaigns";

export class CampaignService {
  public static async getBrandsBilling(
    searchQuery?: string,
    linkedBrands?: string[],
    limit?: number,
    pageNo?: number
  ): Promise<BackednResponse<IGetBrandBilling>> {
    const params = new URLSearchParams();
    if (searchQuery) {
      params.append("searchQuery", searchQuery);
    }
    if (limit) {
      params.append("limit", limit.toString());
    }
    if (pageNo) {
      params.append("pageNo", pageNo.toString());
    }
    if (linkedBrands && linkedBrands.length > 0) {
      params.append("linkedBrands", linkedBrands.join("$$"));
    }
    const queryString = params.toString();
    const url = `billing/brand/${queryString ? `?${queryString}` : ""}`;

    return api.get(url).json() as Promise<BackednResponse<IGetBrandBilling>>;
  }
  public static async getBrandBillingById(
    billingId: string
  ): Promise<BackednResponse<IBrandBilling>> {
    return api.get(`billing/brand/${billingId}`).json() as Promise<
      BackednResponse<IBrandBilling>
    >;
  }
  public static async createBrandBilling(
    brandBilling: Partial<IBrandBilling>
  ): Promise<BackednResponse<IBrandBilling>> {
    return api
      .put(`billing/brand`, { json: { ...brandBilling } })
      .json() as Promise<BackednResponse<IBrandBilling>>;
  }
  public static async editBrandBilling(
    billingId: string,
    brandBilling: Partial<IBrandBilling>
  ): Promise<BackednResponse<IBrandBilling>> {
    return api
      .post(`billing/brand`, { json: { ...brandBilling, billingId } })
      .json() as Promise<BackednResponse<IBrandBilling>>;
  }

  public static async linkBrandToBilling(
    billingId: string,
    brandIds: string[]
  ): Promise<BackednResponse<IBrandBilling>> {
    return api
      .post(`billing/brand/link`, { json: { billingId, brandIds } })
      .json() as Promise<BackednResponse<IBrandBilling>>;
  }
  public static async unlinkBrandFromBilling(
    billingId: string,
    brandId: string
  ): Promise<BackednResponse<IBrandBilling>> {
    return api
      .post(`billing/brand/de-link`, { json: { billingId, brandId } })
      .json() as Promise<BackednResponse<IBrandBilling>>;
  }

  public static async getBrandBillingFacets() {
    return (await api
      .get("billing/brand/facets")
      .json()) as BackednResponse<IBillingFacets>;
  }
}
